import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

type B3ModalElement = HTMLElement & { open?: boolean };

@Component({
  standalone: false,
  selector: 'app-operation-confirmation-reject-modal',
  templateUrl: './operation-confirmation-reject-modal.component.html',
  styleUrls: ['./operation-confirmation-reject-modal.component.scss'],
})
export class OperationConfirmationRejectModalComponent {
  @ViewChild('rejectModal') rejectModal?: ElementRef<B3ModalElement>;

  @Input() open = false;

  @Output() closed = new EventEmitter<boolean>();

  onCancel(): void {
    this.closeModal(false);
  }

  onConfirm(): void {
    this.closeModal(true);
  }

  onModalDismiss(): void {
    this.closeModal(false);
  }

  private closeModal(confirmed: boolean): void {
    const modalHost = this.rejectModal?.nativeElement;
    if (modalHost) {
      modalHost.open = false;
    }

    document.querySelectorAll('dialog[open]').forEach(element => {
      if (element instanceof HTMLDialogElement) {
        element.close();
      }
    });

    this.closed.emit(confirmed);
  }
}
